import React from 'react';
import StockFunctional from './components/stock-list-functional';
import './load-out.scss';

const Stock = () => {
	return <StockFunctional />;
};

export default Stock;
